'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _propTypes3 = require('utils/prop-types');

var _clipboard = require('helpers/clipboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ShareLinkPopover.scss');

var ShareLinkPopover = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ShareLinkPopover, _PureComponent);

  function ShareLinkPopover() {
    (0, _classCallCheck3.default)(this, ShareLinkPopover);
    return (0, _possibleConstructorReturn3.default)(this, (ShareLinkPopover.__proto__ || (0, _getPrototypeOf2.default)(ShareLinkPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShareLinkPopover, [{
    key: 'copyLink',
    value: function copyLink() {
      var _props = this.props,
          link = _props.link,
          onCopy = _props.onCopy;

      var result = (0, _clipboard.copyTextToClipboard)(link);
      onCopy(result);
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.context.t;
      var _props2 = this.props,
          id = _props2.id,
          link = _props2.link,
          _props2$title = _props2.title,
          title = _props2$title === undefined ? t('Share the link') : _props2$title,
          rest = (0, _objectWithoutProperties3.default)(_props2, ['id', 'link', 'title']);


      return _react2.default.createElement(
        _Popover2.default,
        (0, _extends3.default)({ id: id }, rest),
        _react2.default.createElement(
          'div',
          { className: styles.popoverContainer },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: styles.inputContainer },
            _react2.default.createElement('input', { type: 'text', value: link, readOnly: true, className: styles.input }),
            _react2.default.createElement(_Loader2.default, { small: true, mask: true, show: !link, transparent: true })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(
              _Button2.default,
              { className: 'btn-stroke squared small', onClick: this.copyLink, disabled: !link },
              t('Copy link')
            )
          )
        )
      );
    }
  }]);
  return ShareLinkPopover;
}(_react.PureComponent), _class2.propTypes = {
  id: _propTypes2.default.string.isRequired,
  link: _propTypes2.default.string,
  onCopy: _propTypes2.default.func,
  title: _propTypes3.node
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  link: '',
  onCopy: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'copyLink', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'copyLink'), _class.prototype)), _class);
exports.default = ShareLinkPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareLinkButton/ShareLinkPopover.js
// module id = 2096
// module chunks = 1